module.exports = __webpack_public_path__ + "img/top2@3x.d6fccfc9.png";